type SeoMeta = {
  name?: string;
  content?: string;
};

type SeoModel = {
  title?: string;
  meta?: SeoMeta[];
};

const getMetaInfo = (seoModel?: SeoModel | null) => ({
  titleTemplate: seoModel?.title,
  meta: seoModel?.meta?.map((m) => ({ name: m.name, content: m.content })),
});

export {
  getMetaInfo,
};
